module.exports = __webpack_public_path__ + "img/layanan.7b76638.png";